import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

// Components
import CodingEditor from 'app/views/components/CodingEditor'
import GenericModal from 'app/views/components/Modals/GenericModal'
import ModalAboutThisEnvironment from 'app/views/components/Modals/Info/ModalAboutThisEnvironment'
import TipsForGettingOutput from 'app/views/components/TipsForGettingOutput'

// Redux
import {
  replOnPatch,
  replSetCode,
  replSetLocalCode,
  setReplIsPullingCode,
  replSetEngine,
} from 'app/state/modules/repl'

// Settings
import settings from 'settings'

// Utils
import analytics from 'app/views/utils/analytics'
import Icon from 'app/views/components/Icon'
import { updateCode } from "../../../state/modules/k8s";

const propTypes = {
  code: PropTypes.string,
  hasTest: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object, // withRouter
  }).isRequired,
  onReplSetEngine: PropTypes.func.isRequired,
  onReplOnPatch: PropTypes.func.isRequired,
}
const defaultProps = {
  code: '\n',
}


class CodeEditor extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      patchedCode: '',
      isFullScreen: false,
    }

    this.onFullScreen = this.onFullScreen.bind(this)
    this.handleEngineChange = this.handleEngineChange.bind(this)
    this.handlePatchSoftware = this.handlePatchSoftware.bind(this)
    this.handleClickSubmit = this.handleClickSubmit.bind(this)
    this.handleClickConfirm = this.handleClickConfirm.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.handleChangeCode = this.handleChangeCode.bind(this)
    this.onPullCode = this.onPullCode.bind(this)
    this.codingEditor = React.createRef()
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown)
    this.onPullCode(this.props.engine)
  }

  componentDidUpdate(prevProps) {
    // TODO components shouldn't be firing off requests in response to props changes
    if (prevProps.proxyStatus === 'disabled' && this.props.proxyStatus === 'listening' && (this.props.localCode === '' || this.props.localCode === null)) {
      this.onPullCode(this.props.engine)
    }
    if (prevProps.engine !== this.props.engine) {
      this.onPullCode(this.props.engine)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown(e) {
    if (e.key === 'Escape') {
      this.setState({
        isFullScreen: false,
      })
    }
  }

  onFullScreen() {
    const { isFullScreen } = this.state
    this.height = document.querySelector('#code-header').clientHeight * 2
    this.setState({
      isFullScreen: !isFullScreen,
    })
  }

  onPullCode(engine) {
    this.props.setReplIsPullingCode(true)
    this.props.rePullCode(engine)
  }

  getEngine() {
    return this.props.engine
  }

  handleChangeCode(currentCode) {
    this.props.replSetLocalCode(currentCode)
  }

  handleEngineChange(e) {
    const engine = e.target.value
    analytics.track('click-change-engine', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      engine,
    })
    this.setState({
      patchedCode: '',
    }, () => {
      this.props.onReplSetEngine(engine)
    })
  }

  handlePatchSoftware() {
    this.setState({ isFullScreen: false })
    analytics.track('click-patch-code', {
      lessonId: this.props.match.params.id,
      taskId: this.props.ecsTaskDefinition,
      engine: this.state.engine,
    })
    const patchedCode = this.props.localCode
    this.setState({ patchedCode })
    if (this.props.socket) {
      this.props.socket.emit('push-code', {
        engine: this.props.engine,
        data: patchedCode,
      })
    } else {
      this.props.updateCode(this.props.engine, patchedCode)
    }
    const contentId = this.props.match.path === '/demo' ? 'eafe3f4c-70d1-4614-a27f-88957ca9eab7' : this.props.match.params.id
    this.props.onReplOnPatch(contentId, this.props.engine, patchedCode, this.props.hasTest, this.props.isNative ? () => { } : false)
    if (this.props.onPatch !== undefined) {
      this.props.onPatch()
    }
  }

  handleClickSubmit() {
    this.quizModal.show()
  }

  handleClickConfirm() {
    this.quizModal.hide()
    this.props.onSubmitClick(this.props.localCode)
    this.setState({
      patchedCode: '',
    })
  }

  render() {
    const { isFullScreen } = this.state
    let barCss = {}
    let dropdownCss = {}
    if (this.props.displayBar === true) {
      barCss = { background: '#EEEEEE' }
      dropdownCss = { backgroundColor: '#EEEEEE' }
    }

    let patchButtonDisabled = false
    if (this.props.localCode === this.props.code || this.state.patchedCode === this.props.localCode) {
      patchButtonDisabled = true
    }

    let submitButtonDisabled = false
    if (this.state.patchedCode === '') {
      submitButtonDisabled = true
    }

    return (
      <div
        style={isFullScreen ? {
          position: 'fixed',
          width: '100%',
          height: '100%',
          left: 0,
          top: 0,
          backgroundColor: this.props.isLight ? '#EEEEEE' : '#232323',
          zIndex: 1000,
        } : {}}
      >
        <div
          id="code-header"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: this.props.isLight ? '#EEEEEE' : null,
          }}
        >
          <div style={barCss} className="uk-padding-small" id="tour-language-selector">
            <span className="uk-text-small uk-text-bold uk-margin-small-right">Language:</span>
            <div data-uk-form-custom="target: > * > span:first-child" style={dropdownCss}>
              <select name="select" value={this.props.engine} onChange={this.handleEngineChange} data-test-id="tour-language-selector">
                {this.props.engines.map((engine) => (
                  <option key={engine} value={engine}>{settings.engines[engine]}</option>
                ))}
              </select>
              <button className="uk-button uk-button-default uk-padding-small uk-padding-remove-vertical" type="button" tabIndex="-1">
                <span />
                <Icon
                  className="uk-margin-left"
                  name="arrow-down-s"
                />
              </button>
            </div>
          </div>
          <div
            className="uk-padding-small"
          >
            <Icon
              name={`${isFullScreen ? 'fullscreen-exit' : 'fullscreen'}`}
              onClick={this.onFullScreen}
              style={{
                cursor: 'pointer',
              }}
            />
          </div>
        </div>
        <div className={`uk-padding-small${isFullScreen ? ' uk-padding-remove-top' : ''}`}>
          {!this.props.isPullingNewCode && (
            <CodingEditor
              isLesson
              ref={this.codingEditor}
              contentUUID={this.props.contentUUID}
              code={this.props.localCode || ''}
              isLoadingNewCode={this.props.isPullingNewCode}
              engine={this.props.engine}
              id="editor"
              onChange={this.handleChangeCode}
              height={`${isFullScreen ? (window.innerHeight - ((this.height || 0))).toString() : '400'}px`}
            />
          )}
          <div className={`uk-text-small uk-margin-small-top uk-text-right${isFullScreen ? ' uk-position-absolute uk-position-bottom-right uk-margin-small-bottom uk-margin-small-right' : ' uk-width-1-1'}`}>
            <a
              className="uk-link-reset"
              data-uk-toggle="target: #modal-info-about-this-environment"
              href="#"
            >
              About this environment
            </a>
            <ModalAboutThisEnvironment engine={this.props.engine} />
          </div>
          <div className="">
            <button
              data-test-id="code-editor-submit-btn"
              id="tour-submit-patch"
              className={`uk-button uk-button-secondary tm-button-default${isFullScreen ? '' : ' uk-margin'}`}
              style={isFullScreen ? {
                margin: '15px 0px',
              } : {}}
              onClick={this.handlePatchSoftware}
              type="button"
              disabled={patchButtonDisabled}
            >
              Patch Sandbox
            </button>
            {(this.props.displaySubmitButton === true) && (
              <button
                id="tour-submit-answer"
                className="uk-button uk-button-primary uk-align-right"
                onClick={this.handleClickSubmit}
                type="button"
                disabled={submitButtonDisabled}
              >
                Submit Answer
              </button>
            )}
          </div>

          {(this.props.displaySubmitButton === true) && (
            <p className="uk-text-meta uk-margin-remove-top">
              *Change the code above and patch the sandbox. When you are happy
              with your answer, submit it for evaluation!
            </p>
          )}

          {(this.props.displaySubmitButton !== true && !isFullScreen) && (
            <TipsForGettingOutput />
          )}
        </div>
        <GenericModal
          id="modal-quiz-confirm"
          ref={(ref) => { this.quizModal = ref }}
          body={(
            <>
              <div className="uk-text-center">
                <h3>Are you are ready to submit your answer?</h3>
                <p>The next question will start once you have confirmed your answer.</p>
              </div>
            </>
          )}
          cancelLeft
          buttons={(
            <>
              <button
                type="button"
                onClick={this.handleClickConfirm}
                className="uk-button uk-button-primary tm-button-primary uk-align-right uk-margin-remove-bottom"
              >
                Yes, submit answer
              </button>
            </>
          )}
        />
      </div>
    )
  }
}

CodeEditor.propTypes = propTypes
CodeEditor.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  code: state.repl.code,
  localCode: state.repl.localCode,
  engine: state.repl.engine,
  engines: state.repl.engines,
  proxyStatus: state.proxy.status,
  isPullingNewCode: state.repl.isPullingNewCode,
})

const mapDispatchToProps = (dispatch) => ({
  onReplOnPatch: (contentId, engine, code, hasTest, isNative) => dispatch(replOnPatch(contentId, engine, code, hasTest, isNative)),
  updateCode: (engine, code) => dispatch(updateCode(engine, code)),
  replSetLocalCode: (localCode) => dispatch(replSetLocalCode(localCode)),
  setReplIsPullingCode: (isPullingNewCode) => dispatch(setReplIsPullingCode(isPullingNewCode)),
  replSetEngine: (engine) => dispatch(replSetEngine(engine)),
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CodeEditor))
